import { ol_Feature, ol_MapBrowserEvent, ol_MapBrowserPointerEvent, ol_Observable_unByKey } from "@omnia/exports/openlayers";
import { Layer } from "./layer";
import { IMapContainer } from "./types";

export class ClickHandler {

    private _disposeWatchers: Function;

    public contextMenuPosition: number[];

    constructor(private $scope: ng.IScope, private map: IMapContainer, private layers: Layer[], private hitTolerance?: number) {

        this.setupMapClickListener();

    }

    private setupMapClickListener() {

        let olmap = this.map.getMap();

        let clickListenerKey = olmap.on("click", (event: ol_MapBrowserPointerEvent) => this.handleClick(event, false));

        let dblclickListenerKey = olmap.on("dblclick", (event: ol_MapBrowserPointerEvent) => this.handleClick(event, true));

        let contextMenuListener = e => this.handleContextMenu(e);

        let viewport = olmap.getViewport();

        viewport.addEventListener("contextmenu", contextMenuListener);

        this._disposeWatchers = () => {
            ol_Observable_unByKey(clickListenerKey);
            ol_Observable_unByKey(dblclickListenerKey);
            viewport.removeEventListener("contextmenu", contextMenuListener);
        }

    }


    public dispose() {

        if (this._disposeWatchers) {
            this._disposeWatchers();
            this._disposeWatchers = null;
        }

    }

    public handleClick(event: ol_MapBrowserEvent, doubleClick: boolean) {

        if (this.map.getDrawingMode() && (!this.map.getEditMode())) {
            return;
        }

        this.contextMenuPosition = null;

        let originalEvent = <MouseEvent>((<any>event).originalEvent);
        let olmap = event.map;

        if (doubleClick && this.handleDoubleClick(event)) {
            return;
        }

        let options = {
            hitTolerance: this.hitTolerance
        };

        let filter = (feature, layer) => {

            if (this.layers.some(l => l.mapLayer == layer)) {
                return this.checkFeatureSelection(feature);
            }

        };

        olmap.forEachFeatureAtPixel(event.pixel, filter, options);

    }

    public checkFeatureSelection(feature: ol_Feature) {
        return false;
    }

    public handleDoubleClick(event: ol_MapBrowserPointerEvent) {
        return true;
    }

    private handleContextMenu(event: MouseEvent) {

        let olmap = this.map.getMap();

        let pixel = olmap.getEventPixel(event);

        this.contextMenuPosition = pixel;

        this.$scope.$applyAsync();

    }

}
